export default __webpack_public_path__ + "static/media/Pistol_9.9013ae18.png";